<template>
  <a-drawer
    :width="props.width"
    :visible="props.show"
    centered
    placement="right"
    :title="drawerTitle"
    @close="onClose"
  >
    <div class="content_box">
      <div v-if="title == '待审核'" class="content_box_mask" />
      <div v-if="index == 0">
        <div style="white-space: pre-line" v-html="props.info" />
      </div>
      <div v-else>
        <a-alert
          message="提示：为保证学位资料的正确和完整性，请按照要求填写和上传对应内容，避免审核不通过"
          type="info"
        />
        <a-form
          ref="formBox"
          :model="formData"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <div class="title_box">基本信息</div>
          <a-form-item
            label="证件照"
            name="idPhoto"
            :rules="[{ required: true, message: '请上传图片' }]"
          >
            <div class="img-list flex-container">
              <div v-if="formData.idPhoto" class="img-box">
                <a-image :src="formData.idPhoto" alt="avatar" />
                <div class="remove-img" @click.stop="handleRemove('idPhoto')">
                  <close-circle-filled />
                </div>
              </div>
              <a-upload
                v-else
                name="avatar"
                list-type="picture-card"
                accept=".jpg"
                class="avatar-uploader"
                :show-upload-list="false"
                :before-upload="(event) => beforeUpload(event, 1)"
                :custom-request="(event) => onCustomRequest(event, 'idPhoto')"
              >
                <div>
                  <div>
                    <loading-outlined
                      v-if="state.uploadLoading"
                      style="color: rgba(0, 0, 0, 0.85)"
                    />
                    <plus-outlined v-else style="color: rgba(0, 0, 0, 0.85)" />
                  </div>
                  <div>上传</div>
                </div>
              </a-upload>
              <div>
                <a-tooltip
                  placement="topLeft"
                  :overlay-style="{ maxWidth: '300px' }"
                >
                  <template #title>
                    <div class="img-list-tips">
                      1、学生本人近期免冠数码报名照片（即标准证件照）；
                      <br />
                      2、照片的背景色为蓝底；
                      <br />
                      3、照片上着装的颜色应避开与背景相同色调，且无佩饰；
                      <br />
                      4、照片尺寸为480x640像素，分辨率为300DPI以上的JPG文件,不大于300kb；
                      <br />
                      5、请勿上传风景照片；翻拍或扫描的照片、大头照等不符合规定的照片。
                    </div>
                  </template>
                  <span class="img-tips">查看免冠证件照要求</span>
                  <div style="margin-left: 8px">
                    照片须与省考试院毕业申请照片一致
                  </div>
                </a-tooltip>
              </div>
            </div>
          </a-form-item>
          <a-form-item
            label="姓名"
            name="employeeName"
            :rules="[{ required: true, message: '请输入姓名' }]"
          >
            <a-input
              v-model:value.trim="formData.employeeName"
              placeholder="请输入姓名"
              :maxlength="20"
              :disabled="title == '学位申请报名'"
            />
          </a-form-item>
          <a-form-item label="身份证号" name="account">
            <a-input
              v-model:value.trim="formData.account"
              disabled
              placeholder="请输入身份证号"
              :maxlength="18"
            />
          </a-form-item>
          <a-form-item
            label="民族"
            name="nation"
            :rules="[{ required: true, message: '请选择民族' }]"
          >
            <a-select
              v-model:value="formData.nation"
              placeholder="请选择民族"
              :options="nationList"
              show-search
              option-filter-prop="label"
            />
          </a-form-item>
          <a-form-item
            label="专业"
            name="majorId"
            :rules="[{ required: true, message: '请选择专业' }]"
          >
            <a-select
              v-model:value="formData.majorId"
              placeholder="请选择专业"
              :options="title == '学位申请报名' ? state.majorList : majorList"
              disabled
            />
          </a-form-item>
          <a-form-item
            label="准考证号"
            name="examTicketNum"
            :rules="examTicketNumRules"
          >
            <a-input
              v-model:value.trim="formData.examTicketNum"
              placeholder="请输入准考证号"
              :maxlength="20"
            />
          </a-form-item>
          <a-form-item label="首次报考年月" name="year" :rules="yearRules">
            <a-row type="flex">
              <a-date-picker
                v-model:value="formData.year"
                style="width: 201px"
                picker="year"
                format="YYYY"
                @change="handleValidate('year')"
              />
              <a-form-item-rest>
                <a-date-picker
                  v-model:value="formData.month"
                  style="width: 201px"
                  picker="month"
                  format="MM"
                  @change="handleValidate('year')"
                />
              </a-form-item-rest>
            </a-row>
          </a-form-item>
          <a-form-item label="毕业年月" name="year2" :rules="yearRules2">
            <a-row type="flex">
              <a-date-picker
                v-model:value="formData.year2"
                style="width: 201px"
                picker="year"
                format="YYYY"
                @change="handleValidate('year2')"
              />
              <a-form-item-rest>
                <a-date-picker
                  v-model:value="formData.month2"
                  style="width: 201px"
                  picker="month"
                  format="MM"
                  @change="handleValidate('year2')"
                />
              </a-form-item-rest>
            </a-row>
          </a-form-item>
          <a-form-item label="自考毕业证号" name="selfStudyCertificateNumber">
            <a-input
              v-model:value.trim="formData.selfStudyCertificateNumber"
              placeholder="请输入自考毕业证号"
              :maxlength="20"
            />
          </a-form-item>
          <a-form-item
            label="政治思想及学习工作表现（含奖励或处分情况）"
            name="detail"
            :rules="detailRules"
          >
            <a-textarea
              v-model:value="formData.detail"
              placeholder="请输入"
              :auto-size="{ minRows: 5, maxRows: 8 }"
              show-count
              :maxlength="400"
            />
          </a-form-item>

          <div class="title_box">
            相关材料
            <span class="title-tips">图片仅支持jpg，单张最大不可超过1MB</span>
          </div>
          <a-form-item
            style="margin-top: 16px"
            label="身份证"
            name="idCardFront"
            :rules="idCardFrontRules"
          >
            <a-popover trigger="click" placement="bottomLeft">
              <template #content>
                <div style="display: flex">
                  <div style="margin-right: 16px">
                    <div>人像面</div>
                    <a-image
                      :width="200"
                      :src="require('@/assets/example/idcard1.png')"
                    />
                  </div>
                  <div class="content-flex">
                    <div>国徽面</div>
                    <a-image
                      :width="200"
                      :src="require('@/assets/example/idcard2.png')"
                    />
                  </div>
                </div>
              </template>
              <div class="check-example">查看示例图</div>
            </a-popover>
            <div class="img-box">
              <div class="img-list flex-container align-center column">
                <div v-if="formData.idCardFront" class="img-box img-picture">
                  <a-image :src="formData.idCardFront" alt="avatar" />
                  <div
                    class="remove-img"
                    @click.stop="handleRemove('idCardFront')"
                  >
                    <close-circle-filled />
                  </div>
                </div>
                <a-upload
                  v-else
                  name="idcard"
                  list-type="picture-card"
                  accept=".jpg"
                  class="idcard-uploader"
                  :show-upload-list="false"
                  :before-upload="beforeUpload"
                  :custom-request="
                    (event) => onCustomRequest(event, 'idCardFront')
                  "
                >
                  <div>
                    <div>
                      <loading-outlined
                        v-if="state.uploadLoading"
                        style="color: rgba(0, 0, 0, 0.85)"
                      />
                      <plus-outlined
                        v-else
                        style="color: rgba(0, 0, 0, 0.85)"
                      />
                    </div>
                    <div>上传</div>
                  </div>
                </a-upload>
                <div>人像面</div>
              </div>
              <a-form-item-rest>
                <div class="img-list flex-container align-center column">
                  <div v-if="formData.idCardBack" class="img-box img-picture">
                    <a-image :src="formData.idCardBack" alt="avatar" />
                    <div
                      class="remove-img"
                      @click.stop="handleRemove('idCardBack')"
                    >
                      <close-circle-filled />
                    </div>
                  </div>
                  <a-upload
                    v-else
                    name="idcard"
                    list-type="picture-card"
                    accept=".jpg"
                    class="idcard-uploader"
                    :show-upload-list="false"
                    :before-upload="beforeUpload"
                    :custom-request="
                      (event) => onCustomRequest(event, 'idCardBack')
                    "
                  >
                    <div>
                      <div>
                        <loading-outlined
                          v-if="state.uploadLoading"
                          style="color: rgba(0, 0, 0, 0.85)"
                        />
                        <plus-outlined
                          v-else
                          style="color: rgba(0, 0, 0, 0.85)"
                        />
                      </div>
                      <div>上传</div>
                    </div>
                  </a-upload>
                  <div>国徽面</div>
                </div>
              </a-form-item-rest>
            </div>
          </a-form-item>
          <a-form-item
            label="广东省高等教育自学考试考生信息简表"
            name="gdRegistration"
            :rules="[{ required: true, message: '请上传图片' }]"
          >
            <a-popover trigger="click" placement="bottomLeft">
              <template #content>
                <a-image
                  :width="200"
                  :src="require('@/assets/example/gdRegistration.png')"
                />
              </template>
              <div class="check-example top-67">查看示例图</div>
            </a-popover>
            <div class="img-list">
              <div v-if="formData.gdRegistration" class="img-box">
                <a-image :src="formData.gdRegistration" alt="avatar" />
                <div
                  class="remove-img"
                  @click.stop="handleRemove('gdRegistration')"
                >
                  <close-circle-filled />
                </div>
              </div>
              <a-upload
                v-else
                name="avatar"
                list-type="picture-card"
                accept=".jpg"
                class="avatar-uploader"
                :show-upload-list="false"
                :before-upload="beforeUpload"
                :custom-request="
                  (event) => onCustomRequest(event, 'gdRegistration')
                "
              >
                <div>
                  <div>
                    <loading-outlined
                      v-if="state.uploadLoading"
                      style="color: rgba(0, 0, 0, 0.85)"
                    />
                    <plus-outlined v-else style="color: rgba(0, 0, 0, 0.85)" />
                  </div>
                  <div>上传</div>
                </div>
              </a-upload>
            </div>
          </a-form-item>
          <a-form-item name="moeRegistration">
            <template #label>
              <a-tooltip
                placement="topLeft"
                :overlay-style="{ maxWidth: '300px' }"
              >
                <div style="white-space: normal">
                  <span>教育部学历证书电子注册备案表</span>
                  <span>
                    <a-tooltip
                      placement="top"
                      :overlay-style="{ maxWidth: '300px' }"
                    >
                      <template #title>
                        <span style="color: #fff">
                          若未毕业，需上传申请毕业截图
                          <br />
                          若已毕业，则前往学信网下载电子注册备案表
                          <br />
                          *详见示例图
                        </span>
                      </template>
                      <info-circle-outlined style="margin: 0 5px" />
                    </a-tooltip>
                  </span>
                </div>
              </a-tooltip>
            </template>
            <a-popover trigger="click" placement="bottomLeft">
              <template #content>
                <div style="display: flex">
                  <div>
                    <div>申请毕业截图</div>
                    <a-image
                      :width="200"
                      :src="require('@/assets/example/moeRegistration1.png')"
                    />
                  </div>
                  <div>
                    <div>毕业备案表</div>
                    <a-image
                      :width="200"
                      :src="require('@/assets/example/moeRegistration2.png')"
                    />
                  </div>
                </div>
              </template>
              <div class="check-example top-67">查看示例图</div>
            </a-popover>
            <div class="img-list">
              <div v-if="formData.moeRegistration" class="img-box">
                <a-image :src="formData.moeRegistration" alt="avatar" />
                <div
                  class="remove-img"
                  @click.stop="handleRemove('moeRegistration')"
                >
                  <close-circle-filled />
                </div>
              </div>
              <a-upload
                v-else
                name="avatar"
                list-type="picture-card"
                accept=".jpg"
                class="avatar-uploader"
                :show-upload-list="false"
                :before-upload="beforeUpload"
                :custom-request="
                  (event) => onCustomRequest(event, 'moeRegistration')
                "
              >
                <div>
                  <div>
                    <loading-outlined
                      v-if="state.uploadLoading"
                      style="color: rgba(0, 0, 0, 0.85)"
                    />
                    <plus-outlined v-else style="color: rgba(0, 0, 0, 0.85)" />
                  </div>
                  <div>上传</div>
                </div>
              </a-upload>
            </div>
          </a-form-item>
          <!-- <a-form-item
            label="学位申请表"
            name="degreeApplicationUrl"
            :rules="[{ required: true, message: '请上传图片' }]"
          >
            <div class="img-list">
              <div v-if="formData.degreeApplicationUrl" class="img-box">
                <a-image :src="formData.degreeApplicationUrl" alt="avatar" />
                <div
                  class="remove-img"
                  @click.stop="handleRemove('degreeApplicationUrl')"
                >
                  <close-circle-filled />
                </div>
              </div>
              <a-upload
                v-else
                name="avatar"
                list-type="picture-card"
                accept=".jpg"
                class="avatar-uploader"
                :show-upload-list="false"
                :before-upload="beforeUpload"
                :customRequest="
                  (event) => onCustomRequest(event, 'degreeApplicationUrl')
                "
              >
                <div>
                  <div>
                    <loading-outlined
                      style="color: rgba(0, 0, 0, 0.85)"
                      v-if="state.uploadLoading"
                    ></loading-outlined>
                    <plus-outlined
                      style="color: rgba(0, 0, 0, 0.85)"
                      v-else
                    ></plus-outlined>
                  </div>
                  <div>上传</div>
                </div>
              </a-upload>
            </div>
          </a-form-item> -->
          <a-form-item
            name="languageScore"
            :rules="[{ required: true, message: '请上传图片' }]"
          >
            <template #label>
              <a-tooltip
                placement="topLeft"
                :overlay-style="{ maxWidth: '300px' }"
              >
                <span>外语成绩单</span>
                <span>
                  <a-tooltip
                    placement="top"
                    :overlay-style="{ maxWidth: '300px' }"
                  >
                    <template #title>
                      1、可上传
                      <br />
                      ①广东高校联盟外语水平考试成绩单；
                      <br />
                      ②成人高等教育学士学位外国语水平全省统一考试成绩单；
                      <br />
                      2、若有遗失，请上传情况说明书，手写签名后上传至系统并将签名原件邮寄到校；
                      <br />
                      （内容包含：考生个人信息及外语考试年份）
                      <br />
                      *详见图示；
                    </template>
                    <info-circle-outlined style="margin: 0 5px" />
                  </a-tooltip>
                </span>
              </a-tooltip>
            </template>
            <a-popover trigger="click" placement="bottomLeft">
              <template #content>
                <div style="display: flex">
                  <a-image
                    :width="200"
                    :src="require('@/assets/example/languageScore1.png')"
                  />
                  <a-image
                    :width="200"
                    :src="require('@/assets/example/languageScore2.png')"
                  />
                  <a-image
                    :width="200"
                    :src="require('@/assets/example/languageScore3.png')"
                  />
                </div>
              </template>
              <div class="check-example">成绩单图示</div>
            </a-popover>
            <a-popover trigger="click" placement="bottomLeft">
              <template #content>
                <a-image
                  :width="200"
                  :src="require('@/assets/example/languageScore4.png')"
                />
              </template>
              <div class="check-example top-47">情况说明图示</div>
            </a-popover>
            <div class="img-list">
              <div v-if="formData.languageScore" class="img-box">
                <a-image :src="formData.languageScore" alt="avatar" />
                <div
                  class="remove-img"
                  @click.stop="handleRemove('languageScore')"
                >
                  <close-circle-filled />
                </div>
              </div>
              <a-upload
                v-else
                name="avatar"
                list-type="picture-card"
                accept=".jpg"
                class="avatar-uploader"
                :show-upload-list="false"
                :before-upload="beforeUpload"
                :custom-request="
                  (event) => onCustomRequest(event, 'languageScore')
                "
              >
                <div>
                  <div>
                    <loading-outlined
                      v-if="state.uploadLoading"
                      style="color: rgba(0, 0, 0, 0.85)"
                    />
                    <plus-outlined v-else style="color: rgba(0, 0, 0, 0.85)" />
                  </div>
                  <div>上传</div>
                </div>
              </a-upload>
            </div>
          </a-form-item>
          <a-form-item label="其他材料" name="other1">
            <div class="img-box">
              <div class="img-list">
                <div v-if="formData.other1" class="img-box">
                  <a-image :src="formData.other1" alt="avatar" />
                  <div class="remove-img" @click.stop="handleRemove('other1')">
                    <close-circle-filled />
                  </div>
                </div>
                <a-upload
                  v-else
                  name="avatar"
                  list-type="picture-card"
                  accept=".jpg"
                  class="avatar-uploader"
                  :show-upload-list="false"
                  :before-upload="beforeUpload"
                  :custom-request="(event) => onCustomRequest(event, 'other1')"
                >
                  <div>
                    <div>
                      <loading-outlined
                        v-if="state.uploadLoading"
                        style="color: rgba(0, 0, 0, 0.85)"
                      />
                      <plus-outlined
                        v-else
                        style="color: rgba(0, 0, 0, 0.85)"
                      />
                    </div>
                    <div>上传</div>
                  </div>
                </a-upload>
              </div>
              <a-form-item-rest>
                <div class="img-list">
                  <div v-if="formData.other2" class="img-box">
                    <a-image :src="formData.other2" alt="avatar" />
                    <div
                      class="remove-img"
                      @click.stop="handleRemove('other2')"
                    >
                      <close-circle-filled />
                    </div>
                  </div>
                  <a-upload
                    v-else
                    name="avatar"
                    list-type="picture-card"
                    accept=".jpg"
                    class="avatar-uploader"
                    :show-upload-list="false"
                    :before-upload="beforeUpload"
                    :custom-request="
                      (event) => onCustomRequest(event, 'other2')
                    "
                  >
                    <div>
                      <div>
                        <loading-outlined
                          v-if="state.uploadLoading"
                          style="color: rgba(0, 0, 0, 0.85)"
                        />
                        <plus-outlined
                          v-else
                          style="color: rgba(0, 0, 0, 0.85)"
                        />
                      </div>
                      <div>上传</div>
                    </div>
                  </a-upload>
                </div>
                <div class="img-list">
                  <div v-if="formData.other3" class="img-box">
                    <a-image :src="formData.other3" alt="avatar" />
                    <div
                      class="remove-img"
                      @click.stop="handleRemove('other3')"
                    >
                      <close-circle-filled />
                    </div>
                  </div>
                  <a-upload
                    v-else
                    name="avatar"
                    list-type="picture-card"
                    accept=".jpg"
                    class="avatar-uploader"
                    :show-upload-list="false"
                    :before-upload="beforeUpload"
                    :custom-request="
                      (event) => onCustomRequest(event, 'other3')
                    "
                  >
                    <div>
                      <div>
                        <loading-outlined
                          v-if="state.uploadLoading"
                          style="color: rgba(0, 0, 0, 0.85)"
                        />
                        <plus-outlined
                          v-else
                          style="color: rgba(0, 0, 0, 0.85)"
                        />
                      </div>
                      <div>上传</div>
                    </div>
                  </a-upload>
                </div>
              </a-form-item-rest>
            </div>
          </a-form-item>
          <a-form-item
            v-if="title != '学位申请报名'"
            name="isVoluntaryTraining"
            label="是否自愿参加学位论文辅导培训"
            :rules="[
              { required: true, message: '请选择是否自愿参加学位论文辅导培训' },
            ]"
          >
            <a-radio-group v-model:value="formData.isVoluntaryTraining">
              <a-radio value="JOIN">是</a-radio>
              <a-radio value="NOT_JOIN">否</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <template #footer>
      <div class="btn_box">
        <a-button style="margin-right: 12px" @click="onClose">
          {{ title == "待审核" ? "关闭" : "取消" }}
        </a-button>
        <a-button
          v-if="title != '待审核'"
          type="primary"
          :loading="state.loading"
          @click="handleOk"
        >
          {{ index == 0 ? "我已知晓，立即报名" : "确定" }}
        </a-button>
      </div>
    </template>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, watch, defineProps, defineEmits } from "vue";
import {
  PlusOutlined,
  LoadingOutlined,
  CloseCircleFilled,
  InfoCircleOutlined,
} from "@ant-design/icons-vue";
import { message, Modal } from "ant-design-vue";
import dayjs from "dayjs";

import { sdkOssUpimage, getNationJson } from "@/api/common.js";
import { academicDegreeApply } from "@/api/common-paper.js";
import {
  getStudentAccount,
  getUserAccount,
} from "@/api/my_page/student_info/index.js";
import { paperMajorReSignUp, paperSignUp } from "@/api/my_page/paper/index.js";
import { getGuId, extractBirthAndGender } from "@/utils/function";
import { idCardValidate } from "@/utils/validate.js";

const props = defineProps({
  width: {
    type: Number || String,
    default: 660,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  show: {
    type: Boolean,
    default: false,
  },
  info: {
    type: String,
    default: "",
  },
  majorList: {
    type: Array,
    default: () => [],
  },
  data: {
    type: Object,
    default: () => ({}),
  },
  title: {
    type: String,
    default: "",
  },
});
const emit = defineEmits(["update:show", "submit", "update-data"]);

const index = ref(0);
const formData = reactive({});
const formBox = ref(null);

const labelCol = {
  span: 5,
};
const wrapperCol = {
  span: 16,
};

// 图片上传
const fileList = ref([]);
const nationList = ref([]);

// 上传文件（待优化）
const onCustomRequest = async (e, type) => {
  const file = e.file;

  if (type == "idPhoto") {
    // 创建一个 FileReader 对象来读取文件
    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        if (img.width === 480 && img.height === 640) {
          // 图片尺寸符合要求
          uploadFile(file, type);
        } else {
          // 图片尺寸不符合要求
          formData[`${type}List`] = [];
          formData[type] = undefined;
          message.error("图片尺寸必须为 480x640 像素");
        }
      };
      img.onerror = () => {
        message.error("图片加载失败");
      };
      img.src = event.target.result;
    };

    reader.onerror = () => {
      message.error("文件读取失败");
    };

    reader.readAsDataURL(file);
  } else {
    uploadFile(file, type);
  }
};
const uploadFile = async (file, type) => {
  //   state.uploadLoading = true;
  let client = await sdkOssUpimage();
  const fileName = `${client.options.env}/student/${getGuId()}_${file.name}`;
  client.put(fileName, file).then((result) => {
    formData[type] = result.url;
    if (type == "idCardBack") {
      handleValidate("idCardFront");
    } else {
      handleValidate(type);
    }
    // state.uploadLoading = false;
  });
};

/**
 * 移除文件
 **/
const handleRemove = (type) => {
  formData[type] = "";
};

/**
 * 校验当前字段
 **/
const handleValidate = (type) => {
  formBox.value.validate(type);
};

/**
 * 图片上传前的回调
 **/
const beforeUpload = (file, type = 2) => {
  const isJpgOrPng = file.type === "image/jpeg";
  if (!isJpgOrPng) {
    message.error("请上传jpeg格式的文件!");
  }

  let isMaxSize = undefined;

  if (type == 1) {
    isMaxSize = file.size / 1024 < 300;
    if (!isMaxSize) {
      message.error("图片大小不得超过300Kb!");
    }
  } else {
    isMaxSize = file.size / 1024 / 1024 < 1;
    if (!isMaxSize) {
      message.error("图片大小不得超过1MB!");
    }
  }

  return isJpgOrPng && isMaxSize;
};

//根据年月组合
const generateFirstRegistrationTimestamp = (year, month) => {
  const date = dayjs(year);
  const yearValue = date.year(); // 提取年份
  const date2 = dayjs(month);
  const monthValue = date2.month() + 1; // 提取月份，注意：getMonth() 返回 0-11，需要加 1

  // 将年份和月份拼接成一个字符串
  const dateStr = `${yearValue}-${monthValue.toString().padStart(2, "0")}`;

  // 使用 dayjs 将拼接后的字符串转换为时间戳
  const firstRegistrationDate = dayjs(dateStr).valueOf();
  return firstRegistrationDate;
};

// 重新报名
const signUpChange = () => {
  Modal.confirm({
    title: "提示",
    content: "提交后材料不可修改，请确认后再进行提交",
    onOk: async () => {
      // console.log("报名======", params);
      state.loading = true;
      const {
        idPhoto,
        employeeName,
        account,
        nation,
        majorName,
        idCardFront,
        idCardBack,
        gdRegistration,
        moeRegistration,
        // degreeApplicationUrl,
        languageScore,
        other1,
        other2,
        other3,
        examTicketNum,
        year,
        year2,
        month,
        month2,
        selfStudyCertificateNumber,
        detail,
        isVoluntaryTraining,
      } = formData;
      const firstRegistrationDate = generateFirstRegistrationTimestamp(
        year,
        month
      );
      const graduationDate = generateFirstRegistrationTimestamp(year2, month2);
      let params = {
        idPhoto,
        employeeName,
        account,
        nation,
        majorName,
        idCardFront,
        idCardBack,
        gdRegistration,
        moeRegistration,
        // degreeApplicationUrl,
        languageScore,
        other1,
        other2,
        other3,
        examTicketNum,
        firstRegistrationDate,
        graduationDate,
        sex: extractBirthAndGender(account).gender,
        birthday: extractBirthAndGender(account).birthDate,
        selfStudyCertificateNumber,
        detail,
        isVoluntaryTraining,
      };
      try {
        let res = {};
        if (props.title) {
          if (props.title == "学位申请报名") {
            params.paperType = 1;
            params.id = props.data.paperApplyId;
            params.examinationNo = examTicketNum;
            res = await academicDegreeApply(params);
          } else {
            params.paperType = 2;
            params.paperStudentMajorId = props.data.id;
            res = await paperMajorReSignUp(params);
          }
        } else {
          params.id = props.data.id;
          params.paperType = 2;
          params.paperBatchMajorId = props.data.paperBatchMajorId;
          res = await paperSignUp(params);
        }
        state.loading = false;
        message.success("已提交报名信息");
        emit("update-data", 1, res);
        onClose();
      } catch (error) {
        console.log("error==", error);
        state.loading = false;
      }
    },
  });
};

// 点击确定
function handleOk() {
  if (index.value == 0) {
    index.value = 1;
  } else {
    formBox.value.validate().then(() => {
      signUpChange();
    });
  }
}

// 关闭弹窗
function onClose() {
  formBox.value && formBox.value.resetFields();
  index.value = 0;
  fileList.value = [];
  formData.month = undefined;
  formData.month2 = undefined;
  formData.idCardBack = undefined;
  formData.other2 = undefined;
  formData.other3 = undefined;
  emit("update:show", false);
}

const yearRules = [
  {
    required: true,
    validator: (rule, value) => {
      if (!value || !formData.month) {
        return Promise.reject("请选择首次报考年月");
      }
      return Promise.resolve();
    },
  },
];

const yearRules2 = [
  {
    required: true,
    validator: async (rule, value) => {
      if (!value || !formData.month2) {
        return Promise.reject("请选择毕业年月");
      }
      return Promise.resolve();
    },
  },
];

const accountRules = [
  {
    required: true,
    validator: (rule, value) => {
      return idCardValidate(rule, value);
    },
  },
];

const examTicketNumRules = [
  {
    required: true,
    validator: (rule, value) => {
      if (value == null || value.trim() === "") {
        return Promise.reject("请输入准考证号");
      }

      const admissionTicketReg = /^[0-9\-_@#$%&*!()+={}[\];:'",./?|\\^~]+$/;
      if (admissionTicketReg.test(value.trim())) {
        return Promise.resolve();
      } else {
        return Promise.reject("请输入正确的准考证号，准考证号应为数字或符号");
      }
    },
  },
];

const detailRules = [
  {
    required: true,
    validator: (rule, value) => {
      if (value == null || value.trim() === "") {
        return Promise.reject("请输入");
      }

      if (value.length > 300) {
        return Promise.resolve();
      } else {
        return Promise.reject("不能小于300字");
      }
    },
    trigger: ["blur"],
  },
];

const idCardFrontRules = [
  {
    required: true,
    validator: (rule, value) => {
      if (!value || !formData.idCardBack) {
        return Promise.reject("请选择图片");
      }
      return Promise.resolve();
    },
    trigger: ["change"],
  },
];

//预览图片
const previewImg = (type) => {};

const drawerTitle = ref("");
const state = reactive({
  uploadLoading: false,
  loading: false,
  majorList: [],
});
watch(
  () => props.show,
  async (newVal) => {
    if (newVal) {
      if (props.title) {
        // 重新报名
        index.value = 1;
        drawerTitle.value = props.title;
        Object.assign(formData, props.data);
        if (formData.isVoluntaryTraining === "NONE") {
          formData.isVoluntaryTraining = "";
        }
      } else {
        drawerTitle.value = index.value == 0 ? "报名须知" : "确认报名";
      }
      formData.majorId = props.data.majorId;
      getNationJson().then((res) => {
        nationList.value = res.data.map((item) => {
          return {
            value: item,
            label: item,
          };
        });
      });
      try {
        let res = {};
        if (props.title == "学位申请报名") {
          res = await getUserAccount();
          formData.employeeName = res.userName;
          formData.account = res.idCard;
          state.majorList = [
            {
              value: res.majorId,
              label: res.majorName,
            },
          ];
          formData.majorId = res.majorId;
          formData.examTicketNum = res.examinationNo;

          // formData.nation = "汉族";
          // formData.year = dayjs(1733673601000);
          // formData.month = dayjs(1733673601000);
          // formData.year2 = dayjs(1745473601000);
          // formData.month2 = dayjs(1745473601000);
          // formData.examTicketNum = 123123;
          // formData.selfStudyCertificateNumber = 456456;
          // formData.idPhoto =
          //   "http://nanyida.oss-cn-shenzhen.aliyuncs.com/dev/oem/ut90IHcxmN3IXBCXREcjP8ur1Z5IoDQB_2.jpg";
          // formData.idCardFront =
          //   "http://nanyida.oss-cn-shenzhen.aliyuncs.com/dev/oem/ut90IHcxmN3IXBCXREcjP8ur1Z5IoDQB_2.jpg";
          // formData.idCardBack =
          //   "http://nanyida.oss-cn-shenzhen.aliyuncs.com/dev/oem/ut90IHcxmN3IXBCXREcjP8ur1Z5IoDQB_2.jpg";
          // formData.gdRegistration =
          //   "http://nanyida.oss-cn-shenzhen.aliyuncs.com/dev/oem/ut90IHcxmN3IXBCXREcjP8ur1Z5IoDQB_2.jpg";
          // formData.moeRegistration =
          //   "http://nanyida.oss-cn-shenzhen.aliyuncs.com/dev/oem/ut90IHcxmN3IXBCXREcjP8ur1Z5IoDQB_2.jpg";
          // formData.degreeApplicationUrl =
          //   "http://nanyida.oss-cn-shenzhen.aliyuncs.com/dev/oem/ut90IHcxmN3IXBCXREcjP8ur1Z5IoDQB_2.jpg";
          // formData.languageScore =
          //   "http://nanyida.oss-cn-shenzhen.aliyuncs.com/dev/oem/ut90IHcxmN3IXBCXREcjP8ur1Z5IoDQB_2.jpg";
          // formData.other1 =
          //   "http://nanyida.oss-cn-shenzhen.aliyuncs.com/dev/oem/ut90IHcxmN3IXBCXREcjP8ur1Z5IoDQB_2.jpg";
          // formData.other2 =
          //   "http://nanyida.oss-cn-shenzhen.aliyuncs.com/dev/oem/ut90IHcxmN3IXBCXREcjP8ur1Z5IoDQB_2.jpg";
          // formData.other3 =
          //   "http://nanyida.oss-cn-shenzhen.aliyuncs.com/dev/oem/ut90IHcxmN3IXBCXREcjP8ur1Z5IoDQB_2.jpg";
          // formData.examTicketNum = "11233";
          // formData.detail =
          //   "政治思想及学习工作表现（含奖励或处分情况）政治思想及学习工作表现（含奖励或处分情况）政治思想及学习工作表现（含奖励或处分情况）政治思想及学习工作表现（含奖励或处分情况）政治思想及学习工作表现（含奖励或处分情况）政治思想及学习工作表现（含奖励或处分情况）政治思想及学习工作表现（含奖励或处分情况）政治思想及学习工作表现（含奖励或处分情况）政治思想及学习工作表现（含奖励或处分情况）政治思想及学习工作表现（含奖励或处分情况）政治思想及学习工作表现（含奖励或处分情况）政治思想及学习工作表现（含奖励或处分情况）政治思想及学习工作表现（含奖励或处分情况）政治思想及学习工作表现（含奖励或处分情况）政治思想及学习工作表现（含奖励或处分情况）";
        } else {
          res = await getStudentAccount();
        }
        if (res.firstRegistrationDate) {
          res.year = dayjs(res.firstRegistrationDate);
          res.month = dayjs(res.firstRegistrationDate);
        }
        if (res.graduationDate) {
          res.year2 = dayjs(res.graduationDate);
          res.month2 = dayjs(res.graduationDate);
        }
        if (!props.title) {
          formData.detail = undefined;
        }
        Object.assign(formData, res);
        if (formData.isVoluntaryTraining === "NONE") {
          formData.isVoluntaryTraining = "";
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  {
    deep: true,
  }
);
</script>

<style lang="less" scoped>
.content_box {
  width: 100%;
  min-height: 200px;
  overflow: auto;
  padding-bottom: 54px;
  position: relative;
  .content_box_mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
  }
  :deep(.ant-alert) {
    margin-bottom: 16px;
    .ant-alert-message {
      color: red;
    }
  }
  .title_box {
    position: relative;
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    padding-left: 10px;
    font-weight: 600;
    &::before {
      position: absolute;
      left: 0;
      width: 3px;
      height: 18px;
      background: @primary-color;
      content: "";
    }
    .title-tips {
      padding-left: 16px;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.25);
    }
  }
  :deep(.ant-form) {
    .ant-form-item-required {
      white-space: normal;
    }
    label {
      min-height: 32px;
      height: auto;
    }
  }
}
.btn_box {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 99;
  width: 100%;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  border-top: 1px solid #e9e9e9;
}
.item_box {
  margin-bottom: 20px;
}
.img-box {
  display: flex;
}
.check-example {
  position: absolute;
  left: -81px;
  top: 27px;
  color: @primary-color;
  cursor: pointer;
}
.top-67 {
  top: 67px;
}
.top-47 {
  top: 47px;
  left: -95px;
}
.img-list {
  position: relative;
  margin-right: 16px;

  .img-box {
    position: relative;
    width: 94px;
    height: 124px;
    border: 1px dashed #d9d9d9;
    &:hover {
      .remove-img {
        opacity: 1;
      }
    }
    :deep(.ant-image) {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: 100%;
      transform: translate(-50%, -50%);
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .remove-img {
      position: absolute;
      top: -7px;
      right: -7px;
      width: 14px;
      height: 14px;
      opacity: 0;
      transition: opacity 0.3s;
      span {
        color: red;
        font-size: 14px;
        line-height: 0;
        background: #fff;
        border-radius: 10px;
        cursor: pointer;
      }
    }
  }
  .avatar-uploader {
    width: auto;
    :deep(.ant-upload) {
      width: 94px;
      height: 124px;
      margin: 0;
    }
  }
  .idcard-uploader {
    width: auto;
    :deep(.ant-upload) {
      width: 164px;
      height: 94px;
      margin: 0;
    }
  }
  .img-picture {
    width: 164px;
    height: 94px;
  }
  .img-list-tips {
    flex: 1;
    margin-left: 12px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
  }
}
.img-tips {
  margin-left: 8px;
  color: @primary-color;
  cursor: pointer;
}
</style>
